module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_innlandet_neg.f2170705.png";